import React, { useState, useEffect } from 'react';
import {
  FormHelperText,
  FormLabel,
} from '@hid-galaxy-ui/galaxy-react/components/FormElement';
import { useTranslation } from 'react-i18next';
import { getDynamicApiData } from '../../../services/accreditation-forms-service';
import store from '../../../store';
import { getTranslation } from '../../../utils/functions';
import { Dropdown } from '@hid-galaxy-ui/galaxy-react';
import { useDispatch } from 'react-redux';
import allActions from '../../../store/actions';
import Select from 'react-select';

const InputMultiSelect = (props) => {
  const {
    field,
    form,
    label,
    required,
    hint,
    options,
    apiEndpoint,
    isMultiSelect = false,
    useApiForOptions = false,
    ...restProps
  } = props;
  const { url, method, keyParam, valueParam, body } = apiEndpoint || {};

  const { errors, touched } = form;
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const [dropdownOptions, setDropdownOptions] = useState([]);
  const { tenantId, token, formDefId, projectId, eventId } =
    store.getState().formSession;

  useEffect(() => {
    buildOptions();
  }, []);

  const isError = !!(touched[field.name] && errors?.[field.name]);

  const shouldDisplayError = () => touched[field.name] && !!errors[field.name];
  const labelToDisplay = `${t(label)} ${required ? '*' : ':'}`;

  const fetchOptionsFromApi = async () => {
    if (useApiForOptions && url) {
      const parsedUrl = url
        .replace('{tenantId}', tenantId)
        .replace('{formSessionToken}', token)
        .replace('{projectId}', projectId)
        .replace('{eventId}', eventId)
        .replace('{formDefId}', formDefId);

      try {
        const response = await getDynamicApiData(parsedUrl, method, body);
        return response;
      } catch (error) {
        console.error('Error fetching dropdownOptions:', error);
      }
    }
  };

  const buildOptions = async () => {
    if (useApiForOptions) {
      const response = await fetchOptionsFromApi();
      if (response) {
        if (Array.isArray(response)) {
          const mappedOptions = (response ?? []).map((item) => {
            return { value: item[keyParam], label: item[valueParam] };
          });

          dispatch(
            allActions.formSessionActions.setFormSessionDropdownList({
              [field.name]: mappedOptions,
            }),
          );
          setDropdownOptions(mappedOptions);
        } else {
          console.log(
            'Unexpected response format for dropdownOptions:',
            response,
          );
        }
      } else {
        console.log('Error fetching dropdownOptions:', response);
      }
    } else {
      const mappedOptions = options?.map((item) => {
        return { value: item?.key, label: getTranslation(item?.value) };
      });
      if (
        mappedOptions &&
        Array.isArray(mappedOptions) &&
        mappedOptions.length > 0
      ) {
        setDropdownOptions(mappedOptions);
      }
    }
  };

  const onChange = (option) => {
    if (Array.isArray(option)) {
      form.setFieldValue(
        field.name,
        option.map((item) => item.value),
      );
    } else {
      form.setFieldValue(field.name, option.value);
    }
  };

  // const getValue = () => {
  //   if (eventsList) {
  //     return eventsList.filter((option) => field.value.indexOf(option.value) >= 0);
  //   }
  //   return [];
  // };

  const getValue = () => {
    if (dropdownOptions) {
      return dropdownOptions.filter(
        (option) => field.value.indexOf(option.value) >= 0,
      );
    }
    return [];
  };

  console.log('final', dropdownOptions);
  return (
    <div>
      <span style={{ 'font-size': 'small' }}>{labelToDisplay}</span>

      <Select
        {...restProps}
        placeholder="Select"
        id={field.name}
        name={field.name}
        // label={label}
        styles={{
          menuPortal: (base) => ({ ...base, zIndex: 9999 }),
          placeholder: (base) => ({
            ...base,
            ...(shouldDisplayError()
              ? { color: '#f44336' }
              : { color: '#000000' }),
          }),
          control: (base) => ({
            ...base,

            ...(shouldDisplayError() && { 'border-color': '#f44336' }),
            ...(shouldDisplayError() && {
              '&:hover': {
                'border-color': '#f44336',
              },
            }),
            ...(shouldDisplayError() && {
              '&:focus-visible': {
                'border-color': '#f44336',
              },
            }),
          }),
        }}
        isMulti={isMultiSelect}
        options={dropdownOptions}
        value={getValue()}
        onChange={onChange}
        required={required}
      />
      <FormHelperText>
        {shouldDisplayError() ? errors[field.name] : hint}
      </FormHelperText>
    </div>
  );
};

export default InputMultiSelect;
